import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sendmail-info',
  standalone: true,
  imports: [],
  templateUrl: './sendmail-info.component.html',
  styleUrl: './sendmail-info.component.scss'
})
export class SendmailInfoComponent {
  constructor(private router: Router) {}

  goBack() {
    this.router.navigate(['/']); // Redirige vers la page d'accueil ou une autre page
  }
}
